<template>
    <div class="outerCont">
        <div class="mainCont" v-if="selected" @click="$router.push('/'+navigation+'/'+this.routeParams)">
            <button class="entfernenButton" @click.stop="this.kachelEntfernen()">-</button>
            <img class="kachelImage" :src="'/schnellzugriff/'+imgSrc">
            <div class="bottomCont">
                <div class="iconCont">
                    <img :src="'/schnellzugriff/'+iconSrc">
                </div>
                <div class="textCont">
                    <h2>{{ title }}</h2>
                    <p>{{ text }}</p>
                </div>
            </div>
        </div>

        <div class="newCont" v-if="!selected" @click="this.kachelHinzufügen()">
            +
        </div>
    </div>
    <SchnellkachelAuswahl v-if="this.auswahl" @close="this.auswahl = false;" @select="this.kachelAusgewählt"/>
</template>

<script>
import Swal from 'sweetalert2';
import SchnellkachelAuswahl from './SchnellkachelAuswahl.vue';

export default {
    name: 'home',
    components: {
        SchnellkachelAuswahl
    },
    props:{
        selected: Boolean,
        navigation: String,
        imgSrc: String,
        title: String,
        text: String,
        iconSrc: String,
        id: String
    },
    data() {
      return{
        routeParams: String,
        auswahl: false
      }
    },
    methods:{
        kachelAusgewählt(kachel){
            this.$emit('kachelHinzufügen', {id: this.$props.id, data: kachel});
            this.auswahl = false;
            // optional:
            // this.$router.push({ name: kachel.navigation });
        },
        kachelEntfernen(){
            Swal.fire({
                title: "Schnellzugriff wirklich entfernen?",
                showDenyButton: true,
                confirmButtonText: "Ja",
                denyButtonText: `Nein`
            }).then((result) => {
            if (result.isConfirmed) {
                this.$emit('kachelEntfernen', this.$props.id);
            } else if (result.isDenied) {
                return;
            }
            });
        },
        kachelHinzufügen(){
            this.auswahl = true;
        }
    },
    created() {
        this.routeParams = this.$route.params.id;
    },
}
</script>

<style lang="scss" scoped>
.outerCont{
    flex: 1; /* so breit wie möglich */
    background-color: white;
    border: 1px solid rgb(236, 236, 236);
    border-radius: 8px;
    padding: 0.4rem;
    position: relative;

    .mainCont{
        aspect-ratio: 1 / 1; /* Quadrat */
    }

    .kachelImage{
        width: 100%;
        aspect-ratio: 10 / 6;
        overflow:hidden;
        object-fit: cover;
        border-radius: 8px;
    }

    .bottomCont{
        display: flex;

        .iconCont{
            margin-top: 0.2rem;
            width: 17%;

            img{
                width: 100%;
                object-fit: contain;
            }
        }

        .textCont{
            width: 83%;

            h2{
                margin-top: 0.3rem;
                padding-left: 0.2rem;
                font-size: small;
                text-align: left;
                margin-bottom: 0;
            }

            p{
                padding-left: 0.2rem;
                font-size: x-small;
                text-align: left;
                margin-top: 0.4rem;
                font-weight:lighter;
                color:grey;
            }
        }
    }

    .newCont{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center; /* vertikal */
        justify-content: center; /* horizontal */
        font-size: xx-large;
    }
}

.outerCont:hover{
    transform: scale(1.01);
    cursor: pointer;
    box-shadow: 0.5px 0.5px rgb(201, 201, 201);
}

.entfernenButton{
    position:absolute;
    top: -5px;
    right: -5px;
    border-radius: 50%;
    width: 1.2rem;
    height: 1.2rem;
    padding: 0;
    font-weight: bolder;
    background-color: white;
    color: red;
    background-color: white;
    border-color: white;
}

@media screen and (min-width: 400px){
    .mainCont{
        aspect-ratio: unset !important;
        display: flex;
    }

    .kachelImage{
        //max-width: 14rem;
        max-height: 18vh;
        max-width: 14rem;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        margin-left: 0.5rem;
    }

    .iconCont{
        width: 5rem !important;
        display: none !important;
    }

    .textCont{
        width: 100%;

        h2{
            font-size: x-large !important;
            margin-top: 2.3rem !important;
            margin-left: 2rem !important;
        }

        p{
            margin-top: 0.5rem !important;
            font-size: large !important;
            margin-left: 2rem !important;
        }
    }
}
</style>